// --------------------------------------------------
// Unterbrecher nur auf Seite 1 anzeigen
// --------------------------------------------------

function getCurrentCollectionPage() {
    const params = new URLSearchParams(window.location.search);
    const page = parseInt(params.get("page") || "1", 10);

    return isNaN(page) ? 1 : page;
}

function removeCollectionBanners() {
    const currentPage = getCurrentCollectionPage();

    // Auf Seite 1 dürfen die Unterbrecher stehen bleiben
    if (currentPage <= 1) {
        return;
    }

    // Sichtbare Agentur-Unterbrecher entfernen
    document.querySelectorAll(".col-span-banner").forEach(function (banner) {
        banner.remove();
    });

    // Falls einzelne Banner über IDs eingebunden werden
    [
        "banner_one",
        "banner_two",
        "banner_three"
    ].forEach(function (id) {
        const banner = document.getElementById(id);

        if (banner) {
            banner.remove();
        }
    });
}


// --------------------------------------------------
// Beim ersten Laden prüfen
// --------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
    removeCollectionBanners();
});

window.addEventListener("load", function () {
    removeCollectionBanners();
});


// --------------------------------------------------
// Boost rendert das Grid nachträglich per JavaScript.
// Deshalb DOM dauerhaft überwachen.
// --------------------------------------------------

const collectionBannerObserver = new MutationObserver(function () {
    removeCollectionBanners();
});

collectionBannerObserver.observe(document.body, {
    childList: true,
    subtree: true
});


// --------------------------------------------------
// Videos auf Seite 1 starten
// --------------------------------------------------

window.addEventListener("load", function () {

    setTimeout(function () {

        // Auf Folgeseiten keine Banner-Videos starten
        if (getCurrentCollectionPage() > 1) {
            removeCollectionBanners();
            return;
        }

        const video_banner_one = document.getElementById("video_banner_one");

        if (video_banner_one) {
            video_banner_one.muted = true;
            video_banner_one.autoplay = true;
            video_banner_one.loop = true;
            video_banner_one.load();

            video_banner_one.play().catch((error) => {
                console.error(
                    `Video konnte nicht abgespielt werden: ${error.message}`
                );
            });
        }


        const video_banner_two = document.getElementById("video_banner_two");

        if (video_banner_two) {
            video_banner_two.muted = true;
            video_banner_two.autoplay = true;
            video_banner_two.loop = true;
            video_banner_two.load();

            video_banner_two.play().catch((error) => {
                console.error(
                    `Video konnte nicht abgespielt werden: ${error.message}`
                );
            });
        }


        const video_banner_three = document.getElementById("video_banner_three");

        if (video_banner_three) {
            video_banner_three.muted = true;
            video_banner_three.autoplay = true;
            video_banner_three.loop = true;
            video_banner_three.load();

            video_banner_three.play().catch((error) => {
                console.error(
                    `Video konnte nicht abgespielt werden: ${error.message}`
                );
            });
        }

    }, 600);

});